import Crud from '../views/VehicleModel/Crud'
import Entity from '../views/VehicleModel/Add'

let routes = {
    path: '/vehicle_models',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/vehicle_models/add',
            name: 'NewVehicleModel',
            component: Entity,
            meta: {
                pageTitle: 'Vehicle Models',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_models'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_models/edit/:id?',
            name: 'EditVehicleModel',
            component: Entity,
            meta: {
                pageTitle: 'Vehicle Models',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/vehicle_models'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/vehicle_models',
            name: 'list-vehicle_models',
            component: Crud,
            meta: {
                pageTitle: 'Vehicle Models',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
